import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppUser } from '../models/dbmodels';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { BrandService } from '../state';
import { DataService } from './data-api.service';
import { Observable } from 'rxjs';
import { HeartbeatService } from './heartbeat.service';

//import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  //http: HttpClient;
  baseUrl: string = environment.apiUrl;
  currentUser: AppUser = undefined;

  constructor(private http: HttpClient, private router: Router, private brandService: BrandService, private dataService: DataService,
    private heartbeatService: HeartbeatService
  ) {
    //console.log('AuthService.constructor', 'baseUrl', this.baseUrl);
  }

  get token(): string {
    return localStorage.getItem("token");
  }

  set token(token: string) {
    localStorage.setItem("token", token);
  }

  removeToken() {
    localStorage.removeItem("token");
  }

  getDecodedAccessToken(): any {
    try {
      //console.log('AuthService.getDecodedAccessToken', this.token, jwtDecode(this.token));
      return jwtDecode(this.token);
    } catch (Error) {
      return null;
    }
  }

  decodeToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (Error) {
      return null;
    }
  }

  // challenge is to get the method run synchronously
  isAuthenticatedObs(): Observable<boolean> {

    let authObs = this.dataService.IsAuthenticated();
    return authObs; // !!this.token;

  }
  

  clearLocalStorage(){

    const KEEP_PREFIXES = [
      'DT:LAYOUT:',   // keep all datatable layouts
      // add other “static” prefixes here
    ];
    const KEEP_KEYS = [
      'project-list-view',
      'project-orders-list-view',
      'project-quotes-list-view'
    ];

    for (const key of Object.keys(localStorage)) {
      const keep = KEEP_KEYS.includes(key) || KEEP_PREFIXES.some(p => key.startsWith(p));
      if (!keep) localStorage.removeItem(key);
    }
  }

  logout() {
    //console.log('AuthService.logout', 'logging out');
    this.heartbeatService.stop();
    let logoutObs = this.dataService.LogoutUser();
    logoutObs.subscribe((response) => {
      this.brandService.setAppTheme(environment.defaultBrandClass)
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("currentUser");
      localStorage.removeItem("brandId");
      localStorage.removeItem('ImpersonatingUserId');
      this.clearLocalStorage();
      sessionStorage.clear();
      this.currentUser = undefined;
      //close any open modals
      
      //console.log('AuthService.logout', 'clearing local storage', localStorage.getItem("currentUser"), localStorage.getItem("userInfo"), localStorage.getItem("token"));
      //this.router.navigate(["/user/user-login/logout"]);
      //full redirect - removing logout so login doesn't call back
      window.location.href = "/user/user-login";
      
    }, (error) => {
      console.log('AuthService.logout', 'error logging out', error);

      //error on api logout. attempt to clear local storage and session storage
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("currentUser");
      localStorage.removeItem("brandId");
      localStorage.removeItem('ImpersonatingUserId');
      localStorage.clear();
      sessionStorage.clear();
      this.currentUser = undefined;


      //console.log('AuthService.logout', 'clearing local storage', localStorage.getItem("currentUser"), localStorage.getItem("userInfo"), localStorage.getItem("token"));
      //this.router.navigate(["/user/user-login/logout"]);
      //full redirect - removing logout so login doesn't call back
      window.location.href = "/user/user-login";

    });

  }

}
